<template>
  <div class="chat-page-wrap">
    <div class="chat-page-inner">
      <div class="page-body" id="lottie_parent">
        <div class="chat-list">
          <div class="chat-list-title">聊天列表</div>
          <div class="chat-list-scroller">
            <BindLineTip class="bind-line-inner" />
            <template v-if="imConversationList.length">
              <ChatItem
                v-for="(history, index) in imConversationList"
                :key="history.userProfile.userID"
                :index="index"
                :info="history"
                :is-chating="
                  imCurrentConversation &&
                    imCurrentConversation.userProfile.userID ===
                      history.userProfile.userID
                "
                :allow-delete="imConversationList.length !== 1"
                @changeChatUser="changeChatUser"
              />
            </template>
            <template v-else>
              <div class="no-data">
                <span>還沒有對話喔</span>
              </div>
            </template>
          </div>
        </div>
        <div class="chat-main">
          <template v-if="!imConversationList.length">
            <div class="no-data">
              <img src="~@/assets/images/no-data-colorful.png" alt="" />
              <p>您還沒有任何消息</p>
            </div>
          </template>
          <template v-else-if="!imCurrentConversation">
            <div class="no-data">
              <img src="~@/assets/images/no-data-colorful.png" alt="" />
              <p>您還未選中任何好友</p>
              <p>快去跟好友聊一聊吧~</p>
            </div>
          </template>
          <template v-else>
            <div
              class="chat-title"
              :style="{ border: showOrderCard === 1 && 'none' }"
            >
              <div class="no-popver" v-if="imCurrentConversation">
                <fps-icon
                  v-if="isWarnUser"
                  class="wran-icon pointer"
                  type="warning-inline"
                  size="16"
                  color="#E63B37"
                  @click.native.stop="showWarn"
                />
                {{ imCurrentConversation.userProfile.nick }}
                <div
                  v-if="
                    canImpeach &&
                      imCurrentConversation &&
                      imCurrentConversation.userProfile.onlineTime &&
                      !imCurrentConversation.userProfile.canOrder
                  "
                  :class="[
                    'online-wrap',
                    imCurrentConversation &&
                      imCurrentConversation.userProfile.onlineTime === '在線' &&
                      'is-online'
                  ]"
                >
                  {{
                    imCurrentConversation &&
                      imCurrentConversation.userProfile.onlineTime
                  }}
                </div>
                <div
                  v-if="
                    imCurrentConversation &&
                      imCurrentConversation.userProfile.canOrder
                  "
                  class="online-wrap is-online"
                >
                  可接單
                </div>
              </div>
              <el-popover
                v-if="!isBlackUser && skillsList.length && showOrderCard === 2"
                v-model="showOrderPopover"
                trigger="click"
                placement="bottom-end"
                :visible-arrow="false"
                popper-class="im-order-skills"
              >
                <div
                  v-for="skill in skillsList"
                  :key="skill.id"
                  class="order-skill pointer"
                  @click="openOrder(skill)"
                >
                  <div class="msg-wrap">
                    <img class="game-img" :src="skill.gameImageUrl" />
                    <span class="game-name">{{ skill.gameName }}</span>
                  </div>
                  <div
                    class="free-game"
                    v-if="
                      skill.redBagFreeFlag && userInfo && userInfo.hasRedBag
                    "
                  >
                    免費一次
                  </div>
                </div>
                <div class="im-order pointer" slot="reference">
                  <img src="~@/assets/images/im-order.png" />
                  <span>下單</span>
                </div>
              </el-popover>
              <div v-show="showWarnDialog" class="warning-wrap" @click.stop>
                <div class="warning-title">提醒</div>
                <div class="warning-content">
                  該用戶存在違規行為紀錄，請謹慎互動。若發現該用戶有違規行為，請點選『檢舉』進行檢舉，我們將做出對應懲罰。
                </div>
              </div>
            </div>
            <div
              v-if="!isBlackUser && selectSkill && showOrderCard === 1"
              class="order-card"
            >
              <div class="pointer" @click="gotoDetail">
                <img class="game-img" :src="selectSkill.gameImageUrl" />
                <div class="game-info">
                  <div v-if="selectModel" class="info-top">
                    <span class="game-name-wrap"
                      >{{ selectSkill.gameName
                      }}<span class="model-name">{{
                        selectModel.name
                      }}</span></span
                    >
                    <span class="price"
                      >{{ selectModel.showPrice }}幣/{{
                        selectModel.salesUnit | salesUnitTranslate
                      }}</span
                    >
                    <span
                      v-if="selectModel.showPrice !== selectModel.price"
                      class="old-price"
                      >{{ selectModel.price }}幣/{{
                        selectModel.salesUnit | salesUnitTranslate
                      }}</span
                    >
                  </div>
                  <div v-else class="info-top">
                    <span>{{ selectSkill.gameName }}</span>
                    <span class="price"
                      >{{ salePrice > 0 ? salePrice : 0 }}幣/{{
                        selectSkill.salesUnit | salesUnitTranslate
                      }}</span
                    >
                    <span
                      v-if="salePrice !== selectSkill.price"
                      class="old-price"
                      >{{ selectSkill.price }}幣/{{
                        selectSkill.salesUnit | salesUnitTranslate
                      }}</span
                    >
                  </div>
                  <div class="info-bottom">
                    <span class="order-number"
                      >接單{{ selectSkill.countTransactions }}次</span
                    >
                    <span v-if="isSlefSpreadSkill" class="conpon-tag"
                      >新人專屬優惠</span
                    >
                    <div
                      v-else-if="
                        selectSkill.giveAwayList &&
                          selectSkill.giveAwayList.length
                      "
                      class="give-away"
                    >
                      <span
                        v-for="(text, i) in selectSkill.giveAwayList || []"
                        :key="'conpon-tag' + i"
                        class="conpon-tag"
                        >{{ text | parseGiveAway }}</span
                      >
                    </div>
                  </div>
                </div>
                <button
                  class="create-order"
                  @click.stop="openOrder(selectSkill, true)"
                >
                  下單
                </button>
                <div
                  class="show-more pointer"
                  @click.stop="showSelectSkill = true"
                />
              </div>
            </div>
            <div class="chat-message-wrap">
              <div
                class="chat-message"
                ref="chatmessageContainer"
                @scroll="chatViewScroll"
              >
                <div v-for="(msg, index) in imMessageList" :key="index">
                  <ChatMessage
                    ref="chatmessages"
                    :payload="msg.payload"
                    :is-self="msg.isSelf"
                    :avatar="msg.avatar"
                    :time="msg.time"
                    :type="msg.type"
                    :user-profile="imCurrentConversation.userProfile"
                    :is-loading="msg.isLoading"
                    :last-time="
                      imMessageList[index - 1]
                        ? imMessageList[index - 1].time
                        : 0
                    "
                    :isSensitive="msg.isSensitive"
                    :is-uploading="msg.isUploading"
                    :is-last-message="index === imMessageList.length - 1"
                    :orderStatusLoading="orderStatusLoadingList[index]"
                    :myRanking="myRanking"
                    :adverseRanking="adverseRanking"
                    :level="userLevel"
                    :dressup="userDressup"
                    :canImpeach="canImpeach"
                    @orderDetail="orderDetail"
                    @getOrder="chatViewScroll"
                  />
                </div>
                <div id="message-list-placeholder" style="height: 1px;" />
              </div>
            </div>
            <div v-if="isBlackUser" class="chat-input">該用戶已被您封鎖</div>
            <div v-else class="chat-input">
              <div class="textarea">
                <div class="input-tools">
                  <div class="item selector-img-borther">
                    <img
                      class="selector-img"
                      src="~@/assets/images/upload-image-icon-2.png"
                      alt=""
                    />
                    <input
                      id="choose-upload-image-input"
                      type="file"
                      accept="image/png,image/jpg,image/jpeg"
                      @change="chooseUploadImage"
                    />
                  </div>
                  <div class="to-send-gift item">
                    <el-popover
                      placement="top-start"
                      title="禮物"
                      width="399"
                      trigger="click"
                      popper-class="send-gifts-popover"
                      v-model="showSendGift"
                    >
                      <fps-icon
                        class="close-popover"
                        type="close"
                        @click.native="showSendGift = false"
                      />
                      <SendGift
                        ref="send_gift"
                        startPadding="2.5px 7.5px"
                        :playerUserUuid="
                          imCurrentConversation.userProfile.userID
                        "
                        @send_gift_success="sendGiftSuccess"
                      />
                      <fps-icon
                        v-show="canSendGift"
                        class="selector-img gift-icon pointer"
                        slot="reference"
                        type="gift1"
                      />
                    </el-popover>
                  </div>
                </div>
                <textarea
                  id="textarea"
                  class="textarea-box"
                  v-model="sendMessageText"
                  placeholder="請輸入內容"
                  @keypress.enter="pressEnterSendMessage"
                />
              </div>
              <div class="send">
                <span class="tip">按 Enter 鍵發送</span>
                <button
                  class="primary-btn"
                  :disabled="!sendMessageText ? 'disabled' : false"
                  @click="createTextMessage"
                >
                  <i v-if="isSending" class="el-icon-loading"></i>
                  <span v-else>發送</span>
                </button>
              </div>
            </div>
          </template>
        </div>
        <div class="im-loading" v-show="!imSdkReady || !imDataReady">
          <i class="el-icon-loading" />
        </div>
      </div>
      <div class="page-copyright">
        <span>Copyright © 2021 nicee All Right Reserved.</span>
      </div>
    </div>
    <el-dialog
      :visible.sync="showSelectSkill"
      width="375px"
      title="他的技能"
      custom-class="dialog-clear-style order-skill-wrap"
      append-to-body
    >
      <div
        v-for="skill in skillsList"
        :key="skill.id"
        class="order-skill pointer"
        @click="selectOneSkill(skill)"
      >
        <div class="msg-wrap">
          <img class="game-img" :src="skill.gameImageUrl" />
          <span class="game-name">{{ skill.gameName }}</span>
          <img
            v-if="selectSkill.id === skill.id"
            class="selected-img"
            src="~@/assets/image/icons/selected-blue.png"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="orderDetailVisible"
      width="418px"
      append-to-body
      title="訂單詳情"
    >
      <bOrderDetail
        :userType="orderDetailObj.userType"
        :orderNo="orderDetailObj.orderNo"
        :detailVisiable="orderDetailVisible"
        @closeOrderDialog="orderDetailVisible = false"
      />
    </el-dialog>
    <SkillDetail
      v-if="showSkillDetail"
      v-model="showSkillDetail"
      :info="selectSkill"
    />
  </div>
</template>

<script>
import ChatItem from './components/chat-item';
import ChatMessage from './components/chat-message';
import { mapGetters } from 'vuex';
import IM from '@/plugins/im';
import BindLineTip from './components/bind-line-tip';
import SendGift from '@/components/SendGifts';
import bOrderDetail from '@/components/Order/b-order-detail.vue';
import Lottie from '@/components/SendGifts/components/lottie';
import SkillDetail from '@/components/SkillDetail';
import { getWhiteListUserPermissions, checkBlack } from '@/api';
// import axios from 'axios'

export default {
  components: {
    ChatItem,
    ChatMessage,
    BindLineTip,
    SendGift,
    bOrderDetail,
    SkillDetail
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'imSdkReady',
      'imDataReady',
      'imConversationList',
      'imCurrentConversation',
      'imMessageList',
      'accountInfo'
    ]),
    // 裝扮
    userDressup() {
      if (
        this.imCurrentConversation &&
        this.imCurrentConversation.customInfo &&
        this.imCurrentConversation.customInfo.Tag_Profile_Custom_pfpFrame
      ) {
        const { url, time } = JSON.parse(
          this.imCurrentConversation.customInfo.Tag_Profile_Custom_pfpFrame
        );
        return url && new Date().getTime() < time ? url : null;
      } else {
        return null;
      }
    },
    getCurrentMasterId() {
      return this.imCurrentConversation
        ? this.imCurrentConversation.userProfile.userID
        : '';
    },
    canImpeach() {
      if (!this.getCurrentMasterId) return false;
      return ![
        'fpx666',
        this.$store.state.app.adminUuid,
        ...this.$store.state.app.systemUuid
      ].some(id => id == this.getCurrentMasterId);
    },
    pageLoaded() {
      return this.imSdkReady && this.imDataReady;
    },
    couponInfo() {
      if (!this.accountInfo) return false;
      return (
        (this.accountInfo.couponInfoList || null) &&
        this.accountInfo.couponInfoList.find(
          item =>
            item.couponTemplate === 'NEWCOMER_EXPERIENCE' &&
            item.couponStatus === 'EFFECT'
        )
      );
    },
    isSlefSpreadSkill() {
      const { selectSkill } = this;
      if (
        selectSkill &&
        selectSkill.redBagFreeFlag &&
        selectSkill.selfSpreadPrice
      )
        return true;
      return false;
    },
    showFirstOrder() {
      return +this.userInfo.uuid % 2 == 0;
    },
    salePrice() {
      if (!this.selectSkill) return 0;
      const {
        salesPrice,
        selfSpreadPrice,
        firstOrderDiscount,
        firstOrderPrivilege
      } = this.selectSkill;
      if (this.couponInfo) {
        if (this.isSlefSpreadSkill) {
          return selfSpreadPrice - this.couponInfo.couponAmount;
        } else {
          return salesPrice - this.couponInfo.couponAmount;
        }
      } else if (
        firstOrderDiscount &&
        firstOrderPrivilege &&
        this.showFirstOrder
      ) {
        return salesPrice - firstOrderDiscount;
      } else {
        return salesPrice;
      }
    },
    selectModel() {
      if (
        this.selectSkill &&
        this.selectSkill.id === this.selectSkillId &&
        this.selectSkill.skillPriceList
      ) {
        const rs = this.selectSkill.skillPriceList.find(
          item => item.id === this.modelId
        );
        return rs;
      }
      return null;
    }
  },
  data() {
    return {
      showSelectSkill: false,
      canSendGift: false,
      IM,
      toUserId: '',
      orderDetailVisible: false,
      orderDetailObj: {},
      imHasLogin: false,
      isSending: false,
      haveSent: false,
      sendMessageText: '',
      sendMessageTime: '',
      messageList: [],
      chatHistory: [],
      haveChatArr: [],
      hasGetConversationMessage: false,
      chatToUserInfo: {
        userProfile: {},
        lastMessage: {
          payload: {}
        }
      },
      showOrderPopover: false,
      chatUserInfo: null,
      lastDelChat: null,
      textarea: {},
      listenPostMessageTimer: null,
      imSdkFirstReady: false,
      imDataFirstReady: false,
      showSendGift: false,
      skillsList: [],
      orderStatusLoadingList: [],
      // 對方在我的排行榜的名次
      myRanking: null,
      // 我在對方的排行榜的名次
      adverseRanking: null,
      selectSkill: null,
      // 顯示下單卡片 0 都不顯示， 1 卡片， 2 按鈕下拉
      showOrderCard: 0,
      isBlackUser: false,
      // 展示違規人員提示彈窗
      showWarnDialog: false,
      // 對方是否為違規用戶
      isWarnUser: false,
      modelId: 0,
      // 打開im前訪問的技能
      selectSkillId: 0,
      sdkTime: 0,
      beforeCreateTime: 0,
      skillInfo: {},
      showSkillDetail: false,
      // 用户等级(对方)
      userLevel: 0
    };
  },
  watch: {
    pageLoaded(flag) {
      if (flag) {
        if (this.needShowFirstWarn) {
          this.needShowFirstWarn = false;
          this.showFirstWarnDialog();
        }
        if (this.SHOW_GIFT_OBJ) {
          this.$nextTick(() => {
            const giftObj = JSON.parse(sessionStorage[this.SHOW_GIFT_OBJ]);

            Lottie(giftObj);
            delete sessionStorage[this.SHOW_GIFT_OBJ];
          });
        }
      }
    },
    imSdkReady(newVal) {
      // if (value && !this.imSdkFirstReady) {
      //   this.imSdkFirstReady = true
      // }
      console.log('setCurrentChatUser');
      this.sdkTime = new Date().getTime();
      if (newVal && this.toUserId) {
        this.$store.dispatch('im/setCurrentChatUser', this.toUserId);
      }
    },
    // imDataReady(newVal) {
    //   if(newVal) {
    //     let showTime = new Date().getTime()
    //     let time_0 = showTime - this.beforeCreateTime + '_'
    //     let time_1 = this.sdkTime - this.beforeCreateTime + '_'
    //     let time_2 = showTime - this.sdkTime + '_'
    //     showTime = showTime + ''
    //     axios.get('https://www.cloudflare.com/cdn-cgi/trace').then(({data})=>{
    //       let ip = data.slice(data.indexOf('ip=') + 3,data.indexOf('ts=') - 1) + '_'
    //       let string = time_0 + time_1 + time_2 + ip + showTime
    //       gtag('IMTime', string)
    //     })
    //   }
    // },
    imCurrentConversation(value) {
      this.canSendGift = false;
      this.myRanking = null;
      this.adverseRanking = null;
      this.showOrderPopover = false;
      if (this.skillsList.length) {
        this.skillsList = [];
        this.selectSkill = null;
      }
      if (value) {
        this.getCanSend();
        this.seachBlack();
        this.getNewOrderLoadingList = true;
      }
    },
    imMessageList(value) {
      if (this.getNewOrderLoadingList) {
        this.getNewOrderLoadingList = false;
        this.orderStatusLoadingList = new Array(value.length).fill(true);
      } else {
        let length = value.length - this.orderStatusLoadingList.length;
        if (length > 0)
          this.orderStatusLoadingList = this.orderStatusLoadingList.concat(
            new Array(length).fill(true)
          );
      }
    }
  },
  beforeRouteLeave(to) {
    this.$util.openWindow(to.fullPath);
  },
  created() {
    const titleTag = document.getElementsByTagName('title');
    titleTag[0].text = `訊息--nicee陪玩`;
    this.beforeCreateTime = new Date().getTime();
    if (window.opener) {
      const origin = location.protocol + '//' + location.host;

      window.addEventListener('message', event => {
        if (
          event.origin === origin &&
          event.data &&
          event.data.type === 'CHAT_TO_USER_ID'
        ) {
          this.toUserId = event.data.data;
        }
      });

      window.opener.postMessage('LOAD_FINISH', origin);
    }
    const query = this.$route.query;
    if (query.giftObj) {
      const query2 = JSON.parse(JSON.stringify(query));
      this.SHOW_GIFT_OBJ = 'SHOW_GIFT_OBJ';
      sessionStorage[this.SHOW_GIFT_OBJ] = query2.giftObj;
      delete query2.giftObj;
      this.$router.replace({
        query: query2
      });
    }
    if (query.modelId) {
      this.modelId = +query.modelId;
    }
    this.getABParams();
    document.addEventListener('click', this.closeWarnDialog);
  },
  mounted() {
    sessionStorage.setItem('HAS_CHAT_WINDOW', 1);
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('HAS_CHAT_WINDOW');
    });
    this.clearChatInterval = 500;
    // document.body.addEventListener('click', this.setTextareaFocus)

    if (window.name !== this.$util.CHAT_WINDOW_NAME) {
      window.name = this.$util.CHAT_WINDOW_NAME;
    }
  },
  beforeDestroy() {
    // window.removeEventListener('message')
    // document.body.removeEventListener('click', this.setTextareaFocus)
    document.removeEventListener('click', this.closeWarnDialog);
    if (this.warnDialogTimer) {
      clearTimeout(this.warnDialogTimer);
    }
  },
  methods: {
    gotoDetail() {
      this.$util.openWindow(
        `/player-detail/${this.imCurrentConversation.userProfile.userID}?skillId=${this.selectSkill.id}`
      );
    },
    showWarn() {
      this.showWarnDialog = true;
      if (this.warnDialogTimer) {
        clearTimeout(this.warnDialogTimer);
      }
      this.$nextTick(() => {
        this.warnDialogTimer = setTimeout(this.closeWarnDialog, 8000);
      });
    },
    closeWarnDialog() {
      if (this.showWarnDialog) {
        this.showWarnDialog = false;
        clearTimeout(this.warnDialogTimer);
        this.warnDialogTimer = null;
      }
    },
    seachBlack() {
      checkBlack({
        uuid: this.imCurrentConversation.userProfile.userID
      })
        .then(({ data }) => {
          if (data === true) {
            this.isBlackUser = true;
          } else {
            this.isBlackUser = false;
          }
        })
        .catch(() => {});
    },
    getABParams() {
      getWhiteListUserPermissions().then(
        ({ data: { btestOfIMPageOrderBtn } }) => {
          if (btestOfIMPageOrderBtn === 'Open') {
            this.showOrderCard = 1;
          } else {
            this.showOrderCard = 1;
          }
        }
      );
    },
    selectOneSkill(skill) {
      this.selectSkill = skill;
      this.showSelectSkill = false;
    },
    orderDetail(obj) {
      this.orderDetailObj = obj;
      this.orderDetailVisible = true;
    },
    chatViewScroll() {
      const nowTimer = new Date().getTime();
      if (
        this.lastTimer &&
        nowTimer - this.lastTimer < this.clearChatInterval &&
        this.chatTimer
      ) {
        clearTimeout(this.chatTimer);
      }
      this.lastTimer = nowTimer;
      this.chatTimer = setTimeout(() => {
        this.chatTimer = null;
        if (!this.messageContainerObj) {
          this.messageContainerObj = this.$refs.chatmessageContainer.getBoundingClientRect();
        }
        this.$refs.chatmessages.forEach((item, index) => {
          if (item.$refs.orderCard) {
            const domObj = item.$refs.orderCard.getBoundingClientRect();
            if (
              this.messageContainerObj.top <= domObj.top &&
              domObj.top <=
                this.messageContainerObj.top +
                  this.messageContainerObj.height -
                  domObj.height
            ) {
              this.$set(this.orderStatusLoadingList, index, false);
            }
          }
        });
      }, this.clearChatInterval);
    },
    openOrder(skill) {
      this.showOrderPopover = false;
      this.$util.openWindow(
        `/order/check/${skill.id}/1?isHome=${
          skill.redBagFreeFlag ? 'true' : 'false'
        }&price=${this.selectModel ? this.modelId : ''}`
      );
    },
    sendGiftSuccess() {
      this.showSendGift = false;
    },
    // sendGiftSuccess(giftObj) {
    //   this.showSendGift = false
    //   let message = {
    //     isUploading: true
    //   }
    //   const msg = IM.tim.createCustomMessage({
    //     to: this.imCurrentConversation.userProfile.userID,
    //     conversationType: IM.TYPES.CONV_C2C,
    //     payload: {
    //       data: JSON.stringify(giftObj),
    //       description: 'gift',
    //       extension: 'gift'
    //     }
    //   })

    //   Object.assign(message, {
    //     payload: msg.payload,
    //     type: msg.type,
    //     avatar: this.userInfo.avatarUrl,
    //     isSelf: true,
    //     fromUuid: this.userInfo.uuid,
    //     time: msg.time
    //   })

    //   let messageList = this.$store.state.im.messageListMap

    //   messageList.push(message)

    //   this.$store.dispatch('im/updateMessageList', messageList)
    // },
    getCanSend() {
      this.selectSkillId = this.$route.query.skillId
        ? +this.$route.query.skillId
        : 0;
      this.$http
        .post('/master/skill', {
          playerUserUuid: this.imCurrentConversation.userProfile.userID,
          skillId: this.selectSkillId
        })
        .then(rs => {
          if (rs.data.length) {
            this.skillsList = rs.data;
            this.selectSkill = rs.data[0];
          }
        })
        .catch(() => {});
      this.$http
        .get('/user/detail/info', {
          uuid: this.imCurrentConversation.userProfile.userID
        })
        .then(({ data }) => {
          this.canSendGift = data.userKind === 'Player';
          this.myRanking = data.giftRankOrderMy;
          this.adverseRanking = data.giftRankOrderOther;
          this.isWarnUser = data.warningShow;
          this.userLevel = data.userLevel;
          if (data.warningWindow) {
            if (this.imSdkReady && this.imDataReady) {
              this.showFirstWarnDialog();
            } else {
              this.needShowFirstWarn = true;
            }
          }
        })
        .catch(() => {});
    },
    showFirstWarnDialog() {
      this.showWarn();
      this.$http.get('/user/warningWindowClear', {
        uuid: this.imCurrentConversation.userProfile.userID
      });
    },
    jumpHomePage() {
      window.name = '';
      this.$store.dispatch('im/selectConversation', null);
      this.$router.push({
        path: '/'
      });
    },
    pressEnterSendMessage(event) {
      if (!event.shiftKey) {
        event.preventDefault();
        this.createTextMessage();
      }
    },
    createTextMessage() {
      const { sendMessageText } = this;

      if (!sendMessageText) return this.$message.error('請輸入發送內容');

      if (!this.imCurrentConversation)
        return this.$message.error('請選擇發送對象');

      const msg = IM.tim.createTextMessage({
        to: this.imCurrentConversation.userProfile.userID,
        conversationType: IM.TYPES.CONV_C2C,
        payload: {
          text: sendMessageText
        }
      });

      this.sendMessage(msg);
    },
    /**
     * @description 發送消息
     */
    sendMessage(msg) {
      const { isSending } = this;
      if (isSending) return;
      this.isSending = true;
      this.$store
        .dispatch('im/sendMessage', msg)
        .then(result => {
          this.isSending = false;
          if (result.message.type === IM.TYPES.MSG_TEXT) {
            this.sendMessageText = '';
          }
        })
        .catch(errorCode => {
          this.isSending = false;
          if (parseInt(errorCode) === 80001) {
            this.sendMessageText = '';
            this.$message.error('您發送的信息可能包含敏感詞彙，對方無法收到');
          } else if (parseInt(errorCode) === 20007) {
            this.$message.error('您的消息已被對方拒收');
          }
        });
    },
    /**
     * @description 切換聊天對象
     */
    changeChatUser(chatInfo) {
      // if(!chatInfo.userProfile.userID) {
      // this.messageList = []
      // this.chatUserInfo = chatInfo
      // }
      if (!this.imSdkReady) return;

      this.$store.dispatch('im/selectConversation', chatInfo);
    },
    setTextareaFocus(event) {
      const textarea = document.querySelector('#textarea');

      if (!textarea) return;

      if (
        event.target.nodeName &&
        event.target.nodeName.toUpperCase() === 'TEXTAREA'
      ) {
        this.$nextTick(() => {
          textarea.focus();
        });
      } else {
        textarea.blur();
      }
    },
    chooseUploadImage(event) {
      console.log(event.target.files);
      const { files } = event.target;

      if (!files || !files.length) return;

      if (!this.imCurrentConversation)
        return this.$message.error('請選擇發送對象');

      let message = {
        isUploading: true
      };

      const msg = IM.tim.createImageMessage({
        to: this.imCurrentConversation.userProfile.userID,
        conversationType: IM.TYPES.CONV_C2C,
        payload: {
          file: files[0]
        },
        onProgress: event => {
          console.log('file uploading:', event);
          if (event >= 1) {
            message.isUploading = false;
          }
        }
      });

      // Object.assign(message, {
      //   payload: msg.payload,
      //   type: msg.type,
      //   avatar: this.userInfo.avatarUrl,
      //   isSelf: true,
      //   fromUuid: this.userInfo.uuid,
      //   time: msg.time
      // })

      // let messageList = this.$store.state.im.messageListMap

      // messageList.push(message)

      // this.$store.dispatch('im/updateMessageList', messageList)

      this.sendMessage(msg);

      event.target.value = '';
    }
  }
};
</script>
<style lang="scss">
.order-skill-wrap {
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
  .el-dialog__header {
    padding: 16px 18px 8px !important;
    .el-dialog__title {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
    }
    .el-dialog__headerbtn {
      top: 16px;
      right: 18px;
    }
  }
  .el-dialog__body {
    max-height: 280px;
    overflow-y: auto;
    @include hideScrollBar(2px);
  }
  .order-skill {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 18px;
    align-items: center;
    height: 60px;
    &:hover,
    &:active {
      background: #f6f6f6;
    }
    .msg-wrap {
      display: flex;
      width: 100%;
      align-items: center;
    }
    .game-img {
      height: 36px;
      margin-right: 12px;
    }
    .game-name {
      font-size: 16px;
      line-height: 20px;
      color: $color-gray-1;
      flex: 1;
    }
    .free-game {
      background: rgba(56, 186, 124, 0.15);
      border-radius: 4px;
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: -0.3px;
      color: #38ba7c;
    }
    .selected-img {
      height: 24px;
    }
  }
}
.im-order-skills {
  &.el-popover {
    padding: 0;
    margin-top: -7px;
  }
  .order-skill {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    align-items: center;
    &:hover,
    &:active {
      background: #f6f6f6;
    }
    .msg-wrap {
      display: flex;
    }
    .game-img {
      height: 24px;
      margin-right: 9px;
    }
    .game-name {
      margin-right: 30px;
      line-height: 23px;
    }
    .free-game {
      background: rgba(56, 186, 124, 0.15);
      border-radius: 4px;
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: -0.3px;
      color: #38ba7c;
    }
  }
}
</style>
<style lang="scss" scoped>
.order-card {
  background: #ededed;
  width: 100%;
  z-index: 2;
  height: 70px;
  padding: 0 20px 10px;
  & > div {
    border-radius: 8px;
    height: 100%;
    display: flex;
    align-items: center;
    background: #ffffff;
  }
  .game-img {
    height: 40px;
    border-radius: 6px;
    margin: 0 8px 0 12px;
    border-radius: 4px;
  }
  .game-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .info-top {
      display: flex;
      margin-bottom: 6px;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      .game-name-wrap {
        @include flex(flex-start, flex-end);
        .model-name {
          font-size: 13px;
          line-height: 18px;
          font-weight: normal;
          color: $color-gray-2;
          margin-left: 3px;
        }
      }
      .price {
        color: $color-orange;
        margin-left: 12px;
      }
      .old-price {
        font-size: 10px;
        line-height: 14px;
        text-decoration-line: line-through;
        color: $color-gray-3;
        font-weight: 400;
        margin-left: 4px;
      }
    }
    .info-bottom {
      display: flex;
      align-items: center;
      .order-number {
        padding: 2px 3px;
        background: #eeeff2;
        border-radius: 2px;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: -0.4px;
        color: $color-gray-1;
      }
      .conpon-tag {
        margin-left: 3px;
        padding: 2px 3px;
        background: #ffeae6;
        border-radius: 2px;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: -0.4px;
        color: #ea320a;
        &:first-child {
          margin-left: 6px;
        }
      }
      .give-away {
        display: flex;
      }
      .wran-icon {
        margin-right: 6px;
      }
    }
  }
  .create-order {
    background: rgba(0, 122, 255, 0.1);
    border: 1px solid $color-link;
    border-radius: 50px;
    width: 66px;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: $color-link;
    height: 30px;
  }
  .show-more {
    width: 34px;
    height: 100%;
    margin-left: 12px;
    background: url('~@/assets/image/icons/arrow-bottom-gray-2.png') no-repeat
      center center / 14px;
    &:active {
      background-color: $color-split;
    }
  }
}
.warning-wrap {
  position: absolute;
  top: 100%;
  left: 20px;
  right: 20px;
  padding: 20px 20px 25px;
  background: #ffffff;
  border-radius: 15px;
  z-index: 10;
  .warning-title {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: $color-gray-1;
  }
  .warning-content {
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    margin-top: 10px;
    color: $color-gray-1;
  }
}
.chat-title {
  position: relative;
  .no-popver {
    display: flex;
    align-items: center;
    .online-wrap {
      margin-left: 10px;
      display: inline-block;
      padding: 1.5px 3px;
      font-size: 12px;
      line-height: 17px;
      color: #ffffff;
      border-radius: 4px;
      background: $color-offline;
      &.is-online {
        background: $color-green;
      }
    }
    .gift-tag {
      width: 40px;
      margin-left: 3px;
    }
  }
}
.im-order {
  position: absolute;
  height: 100%;
  right: 20px;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover,
  &:active {
    opacity: 0.5;
  }
  img {
    height: 16px;
    margin-right: 5px;
  }
  span {
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
}
.selector-img {
  opacity: 0.7;
  &.gift-icon {
    font-size: 24px;
    color: $color-gray-2;
  }
  &:hover {
    opacity: 1;
  }
}
.selector-img-borther:hover .selector-img {
  opacity: 1;
}
.to-send-gift {
  margin-left: 15px;
}
.chat-page-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  min-height: 612px;
  // @include flex(center, center, column);
  // height: 100vh;

  .chat-page-inner {
    @include flex(flex-start, center, column);
    width: 1100px;
    height: 100%;
    margin: 0 auto;
    padding-top: 36px;
  }
}
.im-loading {
  position: absolute;
  @include flex();
  width: 1100px;
  height: 100%;
  font-size: 20px;
  background: rgba(0, 0, 0, 0.5);
}

.page-title {
  @include flex(flex-start);
  width: 1100px;
  height: 80px;
  flex-shrink: 0;
  margin: auto;
  background: #e5e5e5;
  // box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

  img {
    width: 78px;
    height: 32px;
    cursor: pointer;
  }

  div:not(:last-child) {
    display: none;
  }
}

.page-body {
  @include flex();
  flex-grow: 1;
  flex-shrink: 1;
  width: 1100px;
  height: calc(100vh - 80px);
  min-height: 574px;
  margin: auto;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.page-copyright {
  padding: 20px 0 40px;
  font-size: 14px;
  line-height: 20px;
  color: #999;
}

.chat-list {
  width: 305px;
  height: 100%;
  background: #3e4557;

  .chat-list-title {
    height: 48px;
    padding: 16px 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.7);
    border-bottom: 1px solid rgba(62, 69, 87, 0.5);
  }

  .chat-list-scroller {
    height: calc(100% - 54px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0px;
    }
    .no-data {
      text-align: center;
      padding-top: 124px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 16px;
    }
  }
}
.chat-main {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 795px;
  height: 100%;
  // padding: 0 20px;
  background: #ededed;

  .bind-line-outer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #f6f6f6;
  }

  .bind-line-inner {
    width: 100%;
    background: #f6f6f6;
  }

  .no-data {
    font-size: 0;
    flex: 1;
    @include flex(center, center, column);
    img {
      width: 150px;
      height: 90px;
      margin-bottom: 15px;
    }

    p {
      font-size: 12px;
      line-height: 18px;
      color: #999;
      text-align: center;
    }
  }
}
.chat-message-wrap {
  width: 100%;
  flex: 1;
  overflow: hidden;
  .chat-message {
    // flex-grow: 1;
    // flex-shrink: 0;
    height: 100%;
    width: 100%;
    // height: 324px;
    padding: 15px 20px;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      border-left: none;
    }

    &::-webkit-scrollbar-thumb {
      width: 5px;
      height: 13px;
      border-radius: 10px;
      background: #c4c4c4;
    }
  }
}

.chat-title {
  position: relative;
  @include flex();
  width: 100%;
  height: 48px;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  border-bottom: 1px solid #d0d0d0;
}

.chat-message {
  flex-grow: 1;
  flex-shrink: 0;
  width: 100%;
  height: 324px;
  padding: 15px 20px;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    border-left: none;
  }

  &::-webkit-scrollbar-thumb {
    width: 5px;
    height: 13px;
    border-radius: 10px;
    background: #c4c4c4;
  }
}

.chat-input {
  flex-shrink: 0;
  flex-grow: 0;
  margin: 0 22px;
  height: 193px;
  padding: 10px 8px 20px 0;
  border-top: 1px solid #e0e0e0;

  .send {
    @include flex(flex-end);
    .tip {
      font-size: 14px;
      line-height: 20px;
      color: #999;
      opacity: 0.5;
      margin-right: 20px;
    }
    button {
      @include flex();
      width: 100px;
      height: 36px;
    }
  }
}

.input-tools {
  @include flex(flex-start);
  height: 30px;

  .item {
    position: relative;
    width: 31px;
    height: 24px;
    font-size: 0;

    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
}

.textarea {
  .textarea-box {
    display: block;
    width: 100%;
    height: 65px;
    margin: 20px auto 0;
    color: #333;
    font-size: 14px;
    line-height: 20px;
    // padding: 12px 0;
    resize: none;
    outline: none;
    border: none;

    &::-webkit-input-placeholder {
      color: #999;
      opacity: 0.5;
    }
  }
}
// @media screen and (min-width: 600px) {
//   .set-friend-header {
//     display: none;
//   }
// }
// @media screen and (max-width: 599px) {
//   // .set-friend-header {
//   //   position: absolute;
//   //   top: 0;
//   //   bottom: 0;
//   //   right: 0;
//   //   display: flex;
//   //   align-items: center;
//   // }
//   .chat-page-wrap {
//     width: 100vw;
//     min-height: 100%;
//     bottom: 0;

//     .page-copyright {
//       display: none;
//     }
//   }

//   .chat-page-wrap {
//     .chat-page-inner {
//       width: 100vw;
//       height: 100%;
//       overflow: hidden;
//     }
//   }

//   .page-title,
//   .page-body {
//     width: 100vw;
//   }

//   .page-title {
//     position: relative;
//     display: block;
//     flex-grow: 1;
//     flex-shrink: 0;
//     height: 6vh;
//     background: white;
//     border-bottom: 1px solid #e0e0e0;

//     img {
//       position: absolute;
//       width: 78px;
//       height: 32px;
//       top: 50%;
//       left: 15px;
//       transform: translateY(-50%);
//     }

//     div:not(:last-child) {
//       @include flex();
//       width: 100vw;
//       height: 100%;
//       // padding: 10px;
//       font-size: 16px;
//       color: #333;
//       line-height: 22px;
//       font-weight: 500;
//     }

//     .office-account {
//       font-size: 11px;
//       font-weight: 500;
//       line-height: 16px;
//       color: white;
//       padding: 0 3px;
//       background: #468bdd;
//       border-radius: 2px;
//       margin-left: 4px;
//     }
//   }

//   .page-body {
//     height: 100%;
//     flex-grow: 0;
//     border-radius: 0;
//   }

//   .chat-list {
//     width: 62px;
//     height: 100%;

//     .chat-list-title {
//       height: 40px;
//       font-size: 10px;
//       padding: 13px 10px;
//     }

//     .chat-list-scroller {
//       height: calc(100% - 40px);
//       overflow-y: auto;
//       -webkit-overflow-scrolling: touch;

//       .no-data {
//         display: none;
//       }
//     }
//   }

//   .chat-main {
//     width: calc(100% - 62px);
//     height: 100%;
//     // padding: 0 10px;

//     .chat-title {
//       position: relative;
//       height: 40px;
//       flex-shrink: 0;
//       flex-grow: 0;

//       > span {
//         display: block;
//         width: 250px;
//         text-align: center;
//         @include ellipsis;
//       }
//     }

//     .no-data {
//       img {
//         width: 150px;
//         height: 90px;
//       }
//     }
//   }

//   .chat-message {
//     height: 349px;
//     flex-shrink: 1;
//     flex-grow: 1;
//     padding: 10px;
//     overflow-y: auto;
//     overflow-x: hidden;
//     -webkit-overflow-scrolling: touch;

//     > div:not(:last-child) {
//       padding-bottom: 20px;
//     }
//   }

//   .chat-input {
//     @include flex(flex-start, center, column);
//     width: 100%;
//     height: 253px;
//     flex-shrink: 1;
//     flex-grow: 0;
//     margin: 0;
//     padding: 12px 5px 20px;
//     border-top: 1px solid #e2e2e2;

//     .textarea {
//       width: 100%;
//       flex-grow: 1;
//       height: 73px;

//       .textarea-box {
//         height: 100px;
//         font-size: 16px;
//       }

//       textarea {
//         font-size: 16px;
//       }
//     }

//     .send {
//       width: 100%;
//       height: 36px;
//       flex-shrink: 0;
//       flex-grow: 0;
//       @include flex(flex-end);

//       .tip {
//         display: none;
//       }

//       button {
//         @include flex();
//         width: 100px;
//         height: 36px;
//         color: white;
//         font-size: 16px;
//         font-weight: 500;
//       }

//       button[disabled] {
//         color: white !important;
//         background: linear-gradient(
//           153.64deg,
//           #ff4417 2.04%,
//           #fb006e 60.91%
//         ) !important;
//         opacity: 0.3;
//       }
//     }
//   }
// }
</style>
